
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policies/cookie-settings",
      function () {
        return require("private-next-pages/policies/cookie-settings.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/policies/cookie-settings"])
      });
    }
  